import Vue from "vue";
import VueI18n from "vue-i18n";
// 语言模块zhCn
import zhCn from "./locale/zh-cn/index.js";
import zhHk from "./locale/zh-hk/index.js";
import en from "./locale/en/index.js";
import ja from "./locale/ja/index.js";
import ko from "./locale/ko/index.js";

Vue.use(VueI18n);

const langs = {
  "zh-cn": zhCn,
  "zh-hk": zhHk,
  en: en,
  ja: ja,
  ko: ko
};

/**
 * 创建I18n
 * @returns VueI18n
 */
export function createI18n(lang = "zh-cn") {
  console.log("lang-----", lang);
  return new VueI18n({
    locale: lang || "zh-cn",
    fallbackLocale: "zh-cn",
    messages: langs
  });
}
